__turbopack_context__.v({
  "avatar": "community-card-module-scss-module__fFZG0a__avatar",
  "avatar-fallback": "community-card-module-scss-module__fFZG0a__avatar-fallback",
  "avatar-image": "community-card-module-scss-module__fFZG0a__avatar-image",
  "card": "community-card-module-scss-module__fFZG0a__card",
  "categories": "community-card-module-scss-module__fFZG0a__categories",
  "community": "community-card-module-scss-module__fFZG0a__community",
  "community-name": "community-card-module-scss-module__fFZG0a__community-name",
  "hidden-on-mobile": "community-card-module-scss-module__fFZG0a__hidden-on-mobile",
  "identity": "community-card-module-scss-module__fFZG0a__identity",
  "instructor-name": "community-card-module-scss-module__fFZG0a__instructor-name",
  "item": "community-card-module-scss-module__fFZG0a__item",
  "stats": "community-card-module-scss-module__fFZG0a__stats",
  "text": "community-card-module-scss-module__fFZG0a__text",
});
